import { Component, ViewChild, OnInit, Input, ElementRef } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { IconModel } from '../../models/icon/icon.model';
import { SelectOptionModel } from '../../models/select/select-option.model';
import { SelectOptionStylingModel } from '../../models/select/select-option-styling.model';
import { SelectOptionTemplates } from '../../templates/select-option.template';
import { TemplateService } from '../../services/template-service/template.service';
export class CfSelectOptionComponent extends CfCoreComponent implements OnInit {
/**
 * @hidden
 */
template;
/**
 * <b>SelectModel</b>
 * <p>Example of <b>SelectModel</b> Class:</p>
 * <pre>{{'{'}}
 *  option: 'che',
 *  value: false,
 *  optionValueField: false,
 *  label: this.myFruitsIcon,
 *  optionLabelField: false,
 *  item: false,
 *  optionItemField: true,
 *  icon: true,
 *  optionIconField: 'val'
 * {{'}'}}</pre>
 * <h4>option: any</h4>
 * <p>Option object</p>
 * <h4>value: any</h4>
 * <p>Option value</p>
 * <h4>optionValueField: string</h4>
 * <p>Option property name to be used as option value</p>
 * <h4>label: any</h4>
 * <p>Option label</p>
 * <h4>optionLabelField: string</h4>
 * <p>Option property name to be used as select text when option is selected and as option text if item property is not specified</p>
 * <h4>item: any</h4>
 * <p>Option item</p>
 * <h4>optionItemField: string</h4>
 * <p>Option property name to be used as option item</p>
 * <h4>icon: IconModel</h4>
 * <p>Option icon</p>
 * <h4>optionIconField: string</h4>
 * <p>Option property name to be used as option icon</p>
 */
public properties: SelectOptionModel;
/**
 * <pre>{{'{'}}
 * // Styling of option icon by IconStylingModel
 * icon: IconStylingModel,
 * // Styling of option label by StylingModel
 * label: StylingModel,
 * // Styling of option item by StylingModel
 * item: StylingModel
 * {{'}'}}
 * </pre>
 */
public styling: SelectOptionStylingModel;
/**
 * Option object
 * @param {?} value
 * @return {?}
 */
set option(value: any) { this.properties.option = value; }
/**
 * Option value
 * @param {?} value
 * @return {?}
 */
set value(value: any) { this.properties.value = value; }
/**
 * Option label
 * @param {?} value
 * @return {?}
 */
set label(value: any) { this.properties.label = value; }
/**
 * Option icon
 * @param {?} value
 * @return {?}
 */
set icon(value: IconModel) { this.properties.icon = value; }
/**
 * Option item
 * @param {?} value
 * @return {?}
 */
set item(value: any) { this.properties.item = value; }
/**
 * @hidden
 */
_hasTemplate;
/**
 * @hidden
 */
_templateInited;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new SelectOptionModel();
    this.styling = new SelectOptionStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('select-option', SelectOptionTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'SELECT-OPTION').then(sampler => {
        // console.log('SELECT-OPTION', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-select-option',
  template: "<ng-template #template><ng-content></ng-content></ng-template> ",
  styles: ["[hidden] { display: none !important; } "],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'template': [{ type: ViewChild, args: ['template', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'option': [{ type: Input, args: ['option', ] },],
'value': [{ type: Input, args: ['value', ] },],
'label': [{ type: Input, args: ['label', ] },],
'icon': [{ type: Input, args: ['icon', ] },],
'item': [{ type: Input, args: ['item', ] },],
};
}

function CfSelectOptionComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfSelectOptionComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfSelectOptionComponent.ctorParameters;
/** @type {?} */
CfSelectOptionComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfSelectOptionComponent.prototype.template;
/**
 * <b>SelectModel</b>
 * <p>Example of <b>SelectModel</b> Class:</p>
 * <pre>{{'{'}}
 *  option: 'che',
 *  value: false,
 *  optionValueField: false,
 *  label: this.myFruitsIcon,
 *  optionLabelField: false,
 *  item: false,
 *  optionItemField: true,
 *  icon: true,
 *  optionIconField: 'val'
 * {{'}'}}</pre>
 * <h4>option: any</h4>
 * <p>Option object</p>
 * <h4>value: any</h4>
 * <p>Option value</p>
 * <h4>optionValueField: string</h4>
 * <p>Option property name to be used as option value</p>
 * <h4>label: any</h4>
 * <p>Option label</p>
 * <h4>optionLabelField: string</h4>
 * <p>Option property name to be used as select text when option is selected and as option text if item property is not specified</p>
 * <h4>item: any</h4>
 * <p>Option item</p>
 * <h4>optionItemField: string</h4>
 * <p>Option property name to be used as option item</p>
 * <h4>icon: IconModel</h4>
 * <p>Option icon</p>
 * <h4>optionIconField: string</h4>
 * <p>Option property name to be used as option icon</p>
 * @type {?}
 */
CfSelectOptionComponent.prototype.properties;
/**
 * <pre>{{'{'}}
 * // Styling of option icon by IconStylingModel
 * icon: IconStylingModel,
 * // Styling of option label by StylingModel
 * label: StylingModel,
 * // Styling of option item by StylingModel
 * item: StylingModel
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfSelectOptionComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfSelectOptionComponent.prototype._hasTemplate;
/**
 * @hidden
 * @type {?}
 */
CfSelectOptionComponent.prototype._templateInited;
/**
 * @hidden
 * @type {?}
 */
CfSelectOptionComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
